(()=>{
  const VERSION='5.6.3';

  function init(designer){
    if(designer.dataset.v560Ready)return;
    designer.dataset.v560Ready='true';

    const guard=designer.querySelector('[data-me-exit-guard]');
    const keep=designer.querySelector('[data-me-exit-keep]');
    const save=designer.querySelector('[data-me-exit-save]');
    const discard=designer.querySelector('[data-me-exit-discard]');
    const saveButton=designer.querySelector('[data-me-save-design]');
    const customerId=String(designer.dataset.meCustomerId||'');
    let dirty=false;
    let allowClose=false;
    let pendingCloseButton=null;

    const meaningfulTarget=(target)=>Boolean(target.closest(
      'input:not([type="hidden"]), textarea, select, [data-me-designer-color], [data-me-size-button], [data-me-placement-checkbox], [data-me-quantity-input], [data-me-pp-quantity-minus], [data-me-pp-quantity-plus]'
    ));

    const markDirty=(event)=>{
      if(event.target.closest('[data-me-exit-guard]'))return;
      if(meaningfulTarget(event.target))dirty=true;
    };

    designer.addEventListener('input',markDirty,true);
    designer.addEventListener('change',markDirty,true);
    designer.addEventListener('click',markDirty,true);

    const openGuard=(button)=>{
      pendingCloseButton=button;
      guard.hidden=false;
      requestAnimationFrame(()=>{
        guard.classList.add('is-open');
        keep?.focus();
      });
    };

    const hideGuard=()=>{
      guard.classList.remove('is-open');
      setTimeout(()=>{guard.hidden=true;},180);
    };

    const completeClose=()=>{
      const button=pendingCloseButton||designer.querySelector('.me-designer__close');
      pendingCloseButton=null;
      allowClose=true;
      hideGuard();
      button?.click();
      setTimeout(()=>{allowClose=false;},0);
    };

    designer.addEventListener('click',(event)=>{
      const closeButton=event.target.closest('[data-me-designer-close]');
      if(!closeButton||allowClose)return;
      if(!dirty)return;
      event.preventDefault();
      event.stopImmediatePropagation();
      openGuard(closeButton);
    },true);

    keep?.addEventListener('click',hideGuard);
    discard?.addEventListener('click',()=>{
      dirty=false;
      completeClose();
    });

    save?.addEventListener('click',()=>{
      hideGuard();
      saveButton?.click();
      if(customerId){
        dirty=false;
        setTimeout(completeClose,200);
      }
    });

    guard?.addEventListener('click',(event)=>{
      if(event.target===guard)hideGuard();
    });

    designer.addEventListener('click',event=>{
      const btn=event.target.closest('[data-me-step-button="review"]');
      if(!btn)return;
      const selected=designer.querySelectorAll('input[type="checkbox"]:checked,input[type="radio"]:checked').length;
      if(!selected){
        event.preventDefault();
        const status=designer.querySelector('[data-me-save-design-status]');
        if(status){
          status.hidden=false;
          status.className='me-save-design__status is-warning';
          status.textContent='Choose at least one option before review.';
        }
      }
    });

    window.MomentsDesignerExitGuard={version:VERSION,markClean:()=>{dirty=false;}};
  }

  const boot=()=>document.querySelectorAll('[data-me-designer]').forEach(init);
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',boot):boot();
})();
